import React, { useEffect, Fragment, useRef } from 'react';
import { Popover, Table, Spin, Tooltip } from 'antd';
import Icon from '@ant-design/icons';
import { InfoCircleFilled } from '@ant-design/icons';
import styles from './performance.module.sass';
import { ReactComponent as back_arrow } from '../../../../assets/icons/BackArrow.svg';
import { STATUS } from '../../../../redux/constants';
import VersionCheck from '../../../../shared-components/VersionCheck';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../../../redux/actions/app';

const BackIcon = (props) => (
  <Icon style={{ fontSize: '16px' }} component={back_arrow} {...props} />
);

const columns = [
  {
    title: (
      <Tooltip
        placement={'bottomLeft'}
        title="The name of the feed providing the observable"
      >
        Feed Name
      </Tooltip>
    ),
    dataIndex: 'name',
    key: 'name',
    width: 500,
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (text, record) => <span>{record?.name}</span>,
  },
  {
    title: (
      <Tooltip title={'The name of the owner of the feed'}>Vendor</Tooltip>
    ),
    dataIndex: 'vendor',
    key: 'vendor',
    sorter: (a, b) => a.name.localeCompare(b.name),
    render: (text, record) => <span>{record?.vendor_name}</span>,
  },
  {
    title: (
      <Tooltip
        title={'The interval between updates when the next update will happen'}
      >
        Frequency (hours)
      </Tooltip>
    ),
    dataIndex: 'frequency',
    key: 'frequency',
    sorter: (a, b) => a.frequency - b.frequency,
    render: (text, record) => <span>{record?.frequency}</span>,
  },
  {
    title: (
      <Tooltip
        title={
          'Feed accuracy is based on user feedback regarding the false positives from the threat intelligence feed'
        }
      >
        Accuracy
      </Tooltip>
    ),
    dataIndex: 'acccuracy',
    key: 'accuracy_score',
    sorter: (a, b) => a.accuracy_score - b.accuracy_score,
    render: (text, record) => <span>{record?.accuracy_score}</span>,
  },
  {
    title: (
      <Tooltip
        title={
          'The ratio of the number of false positives with the number of IoCs reported in the feed in the last 30 days'
        }
      >
        False Positive Ratio
      </Tooltip>
    ),
    dataIndex: 'false_positive_ratio',
    key: 'false_positive_ratio',
    sorter: (a, b) => a.false_positive_ratio - b.false_positive_ratio,
    render: (text, record) => <span>{record?.false_positive_ratio}</span>,
  },
  {
    title: (
      <Tooltip
        title={
          "The percentage of the feed's observables that are provided by other feeds/collections"
        }
      >
        Overlap
      </Tooltip>
    ),
    dataIndex: 'overlap_score',
    key: 'overlap_score',
    sorter: (a, b) => a.overlap_score - b.overlap_score,
    render: (text, record) => getOverlapCell(text, record),
  },
  {
    title: (
      <Tooltip
        title={
          'The percentage of firstly reported observables since the feed/collection was added'
        }
      >
        Originator
      </Tooltip>
    ),
    dataIndex: 'originator_score',
    key: 'originator_score',
    sorter: (a, b) => a.originator_score - b.originator_score,
    render: (text, record) => getOriginatorCell(text, record),
  },
];

const getOverlapCell = (text, record) => {
  return text === null ? (
    <Spin spinning={text === null} size="small"></Spin>
  ) : (
    <span>
      <Popover
        content={
          <>
            <div>
              Percentage of items overlapping with other Feeds/Collections
            </div>
            <div>Total IOC: {record?.overlap_explain?.total_ioc}</div>
            <div>Total Overlap: {record?.overlap_explain?.total_overlap}</div>
          </>
        }
      >
        {text} % <InfoCircleFilled />
      </Popover>
    </span>
  );
};

const getOriginatorCell = (text, record) => {
  return text === null ? (
    <Spin spinning={text === null} size="small"></Spin>
  ) : (
    <span>
      <Popover
        content={
          <>
            <div>
              Percentage of firstly reported items since the Feed/Collection was
              added
            </div>
            <div>Total IOC: {record?.originator_explain?.total_ioc}</div>
            <div>
              Total Originator: {record?.originator_explain?.total_originator}
            </div>
          </>
        }
      >
        {text} % <InfoCircleFilled />
      </Popover>
    </span>
  );
};

function Performance(props) {
  const { sourcesReport } = props;
  const dispatch = useDispatch();
  // const lock = useRef(false);

  useEffect(() => {
    document.title = 'Feeds Report - Silent Push';
    dispatch(changeTitle('Feeds Report'));
    props.loadSourcesReports('', '');
    props.loadUser();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    initOverlapAndOriginatorRequests();
  }, sourcesReport);

  const initOverlapAndOriginatorRequests = () => {
    if (sourcesReport !== undefined && sourcesReport?.length > 0) {
      let i = 0;
      let interval = setInterval(() => {
        if (i < sourcesReport?.length) {
          props.loadSourceReport(sourcesReport[i]?.uuid);
          i++;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    }
  };

  return (
    <div className={styles.explore_recipe_pane}>
      <div style={{ marginTop: '22px' }}>
        <Fragment>
          <div className={styles.feed_container}>
            {props?.sourcesReportStatus === STATUS.LOADED ? (
              <Table
                showSorterTooltip={false}
                columns={columns}
                dataSource={sourcesReport}
                pagination={false}
              />
            ) : (
              <Spin style={{ margin: 40 }} />
            )}
            {/* </div> */}
          </div>
        </Fragment>
      </div>
      <VersionCheck parentComponentStatus={props.sourcesReportStatus} />
    </div>
  );
}

export default Performance;
